import { useMutation } from "@tanstack/react-query";
import axios from "axios";

// Function to send email to admin user
const emailAdminUser = async (clientId, projectId, folder, files) => {
  try {
    // Iterate through files and create an array of file names
    const fileNames = files.map((file) => file.name);

    const res = await axios.post(
      `/api/client-file-uploaded/${clientId}/${projectId}/`,
      {
        folder: folder,
        fileNames: fileNames,
      },
      {
        withCredentials: true,
      },
    );

    return res;
  } catch (error) {
    console.error("Error sending email to admin user:", error);
    throw error;
  }
};

export const useEmailAdminUser = (clientId, projectId, enqueueSnackbar) => {
  const sendEmail = useMutation({
    mutationFn: (data) =>
      emailAdminUser(clientId, projectId, data.folder, data.files),
    onError: (error, variables, context) => {
      console.error("Error sending email to admin user:", error);
      enqueueSnackbar("Error notifying Argus about file upload", {
        variant: "error",
      });
    },
    onSuccess: (data, variables, context) => {
      enqueueSnackbar("Argus has been notified about the file(s) upload", {
        variant: "success",
      });
    },
  });

  return sendEmail;
};
